module.exports = window;
